<template>
	<card :type="CardType" :id="'task_'+objTask.id"
	class="ReCardTask lightTheme-BG " 
	
	> 
	<!--:class="[
		{'isVisibleTask':(typeof this.chosenServiceID=='undefined' || this.chosenServiceID == '')},
		{'isVisibleTask':((typeof this.chosenServiceID!='undefined' || this.chosenServiceID != '') && objTask.service_id == this.chosenServiceID)},
		{'isHiddenTask':((this.chosenServiceID != '') && objTask.service_id != this.chosenServiceID)},
		]" -->
		<template v-slot:header><div>
			<template v-for="tag in objTask.TAGS">
				<template v-for="tg in masTags">
					<span v-if="tag.TAG_ID == tg.id"  class="badge badge-success mr-2">{{tg.value}}</span>
				</template>
			</template>
			<!-- <span class="badge badge-pill badge-success mr-1" v-if="objTask.TAGS < 1">Задание</span> -->
			<span class="badge badge-danger mr-2" v-if="objTask.agent_id == '-2'">Хелпдеск</span>

			<span class="mr-2" v-if="typeof objTask.id != 'undefined'">ID: {{objTask.id}}</span>
			<span v-if="objTask.STATUS =='В архиве'" class="badge badge-pill badge-grey ml-2">В архиве</span>
			<div class="date"><span >Дата создания</span><span>{{$GVO.convertDateTimeFromMysql(objTask.InsertTime)}}</span></div>
			<h3 :class="[{'overdue-text':objTask.overdue == '1'}]"  class="mb-0 mt-2">{{objTask.BP_TASK_NAME}}</h3>
		</div></template>
		
		<p class="description" v-if="isShown"><span class="mr-1">Клиент:</span><router-link :to="'/data/clients/id/'+client_id+(client_phone!=''?'?phoneint='+client_phone:'')">{{strFIO}}</router-link></p>
		<p class="description">
			<span class="mr-1">Ответственный:</span>
			<span v-if="agent_id!='-2'"><router-link :to="'/data/staff/id/'+agent_id">{{agent_name}}</router-link></span>
			<span v-else>{{objTask.helpdesk_name}}</span>
		</p>
		
		<div class="BP-row"><p class="description mr-1"><span class="mr-1">Услуга (ID {{objTask.service_id}})</span><span><b>{{BP_NAME}} {{ BP_EXT_NAME }}</b></span></p><!--p class="BP-id">ID услуги: {{objTask.service_id}}</p--></div>
		<!-- <template v-if="typeof objService !='undefined' && typeof objService.CHILD_SERVICES!='undefined' &&  objService.CHILD_SERVICES.length > 0">
			<div class="BP-row" v-for="childService in objService.CHILD_SERVICES" :key="childService.id"><p class="description mr-1">
				<span class="mr-1">Дочерняя услуга (ID {{childService.id}}):</span><span><b>{{childService.BP_NAME}}</b></span></p>
			</div>
		</template> -->
		<template v-if="typeof objService !='undefined' && typeof objService.PARENT_SERVICES!='undefined' && objService.PARENT_SERVICES.length > 0">
			<div class="BP-row" v-for="parentService in objService.PARENT_SERVICES" :key="parentService.id"><p class="description mr-1">
				<span class="mr-1">Родительская услуга (ID {{parentService.id}}):</span><span><b>{{parentService.BP_NAME}}</b></span></p>
			</div>
		</template>
		<!-- <template v-if="typeof objTask !='undefined' && typeof objTask.CHILD_SERVICES!='undefined' && objTask.CHILD_SERVICES.length > 0">
			<div class="BP-row" v-for="childService in objTask.CHILD_SERVICES" :key="childService.id"><p class="description mr-1">
				<span class="mr-1">Дочерняя услуга (ID {{childService.id}}):</span><span><b>{{childService.BP_NAME}}</b></span></p>
			</div>
		</template> -->
		<template v-if="typeof objTask !='undefined' && typeof objTask.PARENT_SERVICES!='undefined' && objTask.PARENT_SERVICES.length > 0">
			<div class="BP-row" v-for="parentService in objTask.PARENT_SERVICES" :key="parentService.id"><p class="description mr-1">
				<span class="mr-1">Родительская услуга (ID {{parentService.id}}):</span><span><b>{{parentService.BP_NAME}}</b></span></p>
			</div>
		</template>
		
		<p class="description mr-1" v-if="(typeof objService != 'undefined') && (objTask.agent_id != objService.agent_id)">
			<span class="mr-1">Ответственный за услугу:</span><span><router-link :to="'/data/staff/id/'+objService.agent_id">{{objService.agent_name}}</router-link></span>
		</p>
		<p class="description" v-if="(objTask.agent_id == '-2') && (objTask.service_agent)">
			<span class="mr-1">Ответственный за услугу:</span>
			<span>{{objTask.service_agent}}</span>
		</p>
		<div class="taskInfo mt-3">
			<div class="description">
				
				<!-- <base-checkbox :checked="typeof objTask.STATUS!='undefined' && objTask.STATUS=='Готово'" disabled inline><h4>{{objTask.BP_TASK_NAME}}</h4></base-checkbox> -->
				<div v-if="objTask.BlockType == 'ClientCall' && isDateLess(objTask.STARTDATE)" class="row mx-0">
					
					<p class="mr-3">Позвоните клиенту здесь </p> 
					<template v-if="typeof objTask.client_phone_list != 'undefined'">
						<template v-for="strPhjoneNo in objTask.client_phone_list.split(',')">							
							<a class="d-inline-block text-success mr-3" v-if="strPhjoneNo != ''">
								<i class="d-inline-block tim-ic ic-phone" @click="$GVO.Call(strPhjoneNo,'TASK',objTask.id)"></i>
								<span @click="$GVO.Call(strPhjoneNo,'TASK',objTask.id)">{{strPhjoneNo}},</span>
							</a>
						</template>
					</template>
					<p> чтобы начать выполнять эту задачу.</p>
						
				</div>
			</div>
			<p class="description taskDeadline" v-if="!isStartDateFar(objTask.DEADLINE)">
				<span v-if="objTask.STATUS=='Готово'" :class="[(objTask.overdue == '1') ? 'text-danger' : 'text-warning']">Время завершения</span>
				<span v-if="objTask.STATUS=='Готово'" :class="[(objTask.overdue == '1') ? 'text-danger' : 'text-warning']">{{ $GVO.convertDateTimeFromMysql(objTask.LeadTime) }}</span>	

				<template v-if="objTask.READONLY != 1 && objTask.editable==1">
					<span v-if="objTask.STATUS!='Готово' && !isStartDateFar(objTask.STARTDATE)" :class="[(objTask.overdue == '1') ? 'text-danger' : 'text-warning']">Срок выполнения до:</span>
					<span v-if="objTask.STATUS!='Готово' && !isStartDateFar(objTask.STARTDATE)" :class="[(objTask.overdue == '1') ? 'text-danger' : 'text-warning']">{{ $GVO.convertDateTimeFromMysql(objTask.DEADLINE) }}</span>
					<span v-if="objTask.overdue != '1' && objTask.STATUS!='Готово' && !isStartDateFar(objTask.STARTDATE)" :class="[(objTask.overdue == '1') ? 'text-danger' : 'text-warning']">(Осталось <ReBackTimer :time="objTask.DEADLINE"/>)</span>
					<span v-if="objTask.overdue == '1' && objTask.STATUS!='Готово'" class="overdue-text">Просрочено</span>
				</template>
			</p>
			<template  v-if="objTask.SUCCESS_ENDDATE != ''">
				<p v-if="objTask.overdue == '1' && objTask.STATUS=='Готово'" class="overdue-text">Просрочено на {{ TimeOverdue() }} </p>
			</template>
			<p v-if="objTask.STATUS =='Готово' || objTask.ResultDescr != null && objTask.ResultDescr !=''" class="results" :class="[{'text-success':objTask.STATUS_END == 'GOOD'},{'text-danger':objTask.STATUS_END == 'OTHER'}]">
				Результат: <span v-html="objTask.ResultDescr" class="mr-2"></span>
				<a v-if="objTask.STATUS =='Готово' || objTask.ResultDescr != null && objTask.ResultDescr !=''" :href="`#${objTask.service_id}`" :id="objTask.service_id" @click="anchorService(objTask.service_id)">Показать услугу</a> 
				<a v-if="typeof objTask.dw_file != 'undefined' && objTask.dw_file != '' && objTask.dw_file != null" :href="objTask.dw_file" target="_blank">Посмотреть документ</a> 
			</p>
			<p v-if="objTask.STATUS =='Готово' && make_id !='-1'" class="results">Кем завершено: {{maker_name}}</p>
			<div v-if="objTask.STATUS =='Готово'" class="results">
				<ReAudioComponent
					v-if="typeof objTask.dw_file !='undefined' && objTask.dw_file != null && objTask.dw_file.indexOf('.mp3') != -1"
					:record="objTask.dw_file"
					showRefresh="false"
					@update-record="handleUpdateRecord(objTask, $event)"
				/>
			</div>
		</div>

		<template v-if="objTask.READONLY == 1 && objTask.editable == 1">
			<div class="text-center mt-2" v-if="objTask.overdue!= '1' && objTask.STATUS!='Готово' && objTask.editable!=0">
				<p class="text-warning">Задача начнется {{isTaskStartTime()}} {{isTimeToTask()}}</p>
				<base-button @click="StartNow()" type="success" >Начать сейчас</base-button>
			</div>
			<div v-else class="d-flex align-items-center"><i class="tim-icons text-danger icon-alert-circle-exc" v-if="objTask.STATUS!='Готово'"></i><p v-if="objTask.STATUS!='Готово'" class="mb-0 ml-1"> Вы не можете выполнить задачу так как не являетесь ответственным или его руководителем.</p></div>
		</template>		
		

		
		<!--div class="crud-container">
				<collapse class="w-100 border-right-0">
					<collapse-item title="Комментарии к задаче" @activate="getDopFields('collapse')" :activeIndex="activeDF">
						<ReCRUDFields v-model="masDopFields" :obj_type="'tasks'" :obj_id="objTask.id" @change="getDopFields" />
					</collapse-item>
				</collapse>
		</div-->

		<template v-if="objTask.READONLY !='1' && editable == 1">
			<div class="taskEndCollapse"> 
				<collapse class="taskEndCollapse w-100 border-right-0" :activeIndex="activeTask" activeIndexType="single">
					<collapse-item title="Выполнить задачу" >
						<!--pre>{{objTask}}</pre-->
						<template >
						<tabs  type="simple" :pillsClass="['success','danger','warning']" :activeTab="this.actTab()" v-model="activeTab"
							@tabschanged="forceTabsUpdate()"
							:key="componentKey"
							tabContentClasses="tab-opt"
							tabNavWrapperClasses="px-0"
							centered
							inline
							square
							class="card card-plain ">
							<tab-pane :id="objTask.id+'_tb1'" :label="objTask.id+'_tb1'" :disabled="!bIsGoodTasks">
								<template v-slot:label><span class="tab-label">
									<i class="tab-icon tim-ic ic-smile"></i><span class="text">Успешно</span>
								</span></template>
								<ReCardTaskEnds
									:objTask="objTask"
									:list="TaskEndsGood"
								/>
								<!--
								<template v-for="taskEnd in objTask.ENDS">
									<ReCardTaskEnd v-if="taskEnd.ttype == 'GOOD'"
									:objTaskEnd="taskEnd"
									:task_id="objTask.id"
									:te_client_id="objTask.client_id"
									:te_service_id="objTask.service_id"
									:VER="objTask.VER"
									:key="'TASKEND_'+taskEnd.id"
									/>
								</template>
								-->
							</tab-pane>

							<tab-pane :id="objTask.id+'_tb2'" :label="objTask.id+'_tb2'" :disabled="!bIsInoeTasks">
								<template v-slot:label><span class="tab-label">
									<i class="tab-icon tim-ic ic-sad"></i><span class="text">Иное</span>
								</span></template>
								<ReCardTaskEnds
									:objTask="objTask"
									:list="TaskEndsBad"
								/>
								<!--
								<template v-for="taskEnd in objTask.ENDS">
									<ReCardTaskEnd v-if="taskEnd.ttype != 'GOOD'"
									:objTaskEnd="taskEnd"
									:task_id="objTask.id"
									:te_client_id="objTask.client_id"
									:te_service_id="objTask.service_id"
									:VER="objTask.VER"
									:key="'TASKEND_'+taskEnd.id"
									/>
								</template>
								-->
							</tab-pane>

							<tab-pane :id="objTask.id+'_tb3'" :label="objTask.id+'_tb3'" v-if="!(!bIsHelpTasks && (objTask.bt_descr=='' || typeof objTask.bt_descr == 'undefined'))">
								<template v-slot:label><span class="tab-label">
									<i class="tab-icon tim-ic ic-question"></i><span class="text">Как это сделать?</span>
								</span></template>
								<p class="px-3 mt-3">{{objTask.bt_descr}}</p>
								<ReCardTaskHelp v-if="typeof objTask.HELPS != 'undefined' && objTask.HELPS.length>0" :masTaskHelp="objTask.HELPS"/>
							</tab-pane>
						</tabs>
						</template>
					</collapse-item>
					
				</collapse>

				<div class="masPrevTaskCollapse">
					<collapse class="w-100 border-right-0" :activeIndex="activeCl" >
						<collapse-item title="Результат предыдущей задачи" @activate="getPrevTask" > 
							<div v-if="masPrevTask.length>0">
								<ul class="list-unstyled result-marker">
									<li v-for="ret in masPrevTask" class="d-flex flex-wrap align-items-baseline">
										<span class="mr-2">{{$GVO.convertTimeDateFromMysql(ret.LeadTime)}}</span>
										<span v-html="ret.ResultDescr" class="d-inline-block mr-1"></span>
										<a v-if="typeof ret.dw_file != 'undefined' && ret.dw_file != null && ret.dw_file != ''" :href="ret.dw_file" target="_blank">Посмотреть документ</a>
									</li>
								</ul>
							</div>
							<div class="d-flex" v-else>
								<base-button @click="getPrevTaskBtn()" type="success" class="mx-auto" simple>Загрузить результаты</base-button>
								<p v-if="strPrevTaskResult!=''">Результатов нет {{ this.strPrevTaskResult }}</p>
							</div>	
						</collapse-item>
					</collapse>
				</div>	

				<div class="crud-container" v-if="editable == 1">
					<collapse class="w-100 border-right-0">
						<collapse-item title="Комментарии к услуге" @activate="getDopFieldsServices('collapse',$event)" :activeIndex="activeDFS">
							<ReCRUDFields v-model="masDopFieldsServices" :obj_type="'services'" :obj_id="objTask.service_id" @change="getDopFieldsServices" />
						</collapse-item>
					</collapse>
				</div>
			</div>	
		</template>

		<template v-else>
			<div class="taskEndCollapse"> 
				<div v-if="editable == 1">
					<collapse class="w-100 border-right-0" :activeIndex="activeCl" >
						<collapse-item title="Результат предыдущей задачи" @activate="getPrevTask" >
							<div v-if="masPrevTask.length>0">
								<ul class="list-unstyled result-marker">
									<li v-for="ret in masPrevTask" class="d-flex flex-wrap align-items-center">
										<span class="mr-2">{{$GVO.convertTimeDateFromMysql(ret.LeadTime)}}</span>
										<span v-html="ret.ResultDescr" class="d-inline-block mr-1"></span>
										<a v-if="typeof ret.dw_file != 'undefined' && ret.dw_file != null && ret.dw_file != ''" :href="ret.dw_file" target="_blank">Посмотреть документ</a>
									</li>
								</ul>
							</div>
							<div class="d-flex" v-else>
								<base-button @click="getPrevTaskBtn()" type="success" class="mx-auto" simple>Загрузить результаты</base-button>
								<p v-if="strPrevTaskResult!=''">Результатов нет {{ this.strPrevTaskResult }}</p>
							</div>
							
						</collapse-item>
					</collapse>
				</div>
			</div>	
		</template>	
	</card>
</template>

<script>
	import { TabPane, Tabs, /*BaseCheckbox,*/ Collapse, CollapseItem } from 'src/components';
	// import ReCardTaskEnd from "src/our_components/ReCardTaskEnd.vue";
	import ReCardTaskHelp from "src/our_components/ReCardTaskHelp.vue";
	import moment from 'moment';
	// import VueMoment from 'vue-moment';
	import ReCRUDFields from 'src/our_components/ReCRUDFields.vue';
	import swal from 'sweetalert2';
	import ReAudioComponent from './ReAudioComponent.vue';
	import ReBackTimer from './ReBackTimer.vue';
	import ReCardTaskEnds from './ReCardTaskEnds.vue';
	

	export default {
		name: 'ReCardTask',
		components: {
			TabPane, Tabs,
			Collapse, CollapseItem,
			// BaseCheckbox,
			// ReCardTaskEnd,
			ReCardTaskHelp,
			ReCRUDFields,
			ReAudioComponent,
			ReBackTimer,
			ReCardTaskEnds,
		},
		props: {
			objTask: Object,
			objService: Object,
			objClient: Object,
			findId: {
				type: String,
				default: '',
			},
			/*
			activeTaskCollapse: {
				type: Boolean,
				default: false,
			},*/
			chosenServiceID: {
				type: [String, Number, Object],
				default: '',
			},
			
		},
		data () {
			return {
				ver: 1,
				bIsInoeTasks: this.isInoeTasks(),
				bIsGoodTasks: this.isGoodTasks(),
				bIsHelpTasks: this.isHelpTasks(),
				agent_name: this.GetAgentName(),
				maker_name: this.GetMakerName(),
				cat_timer: null,
				activeTab: this.actTab(),
				masPrevTask: [],
				activeCl: -1,
				activeDF: -1,
				masDopFields:[],
				activeDFS: -1,
				activeTask: -1,
				masDopFieldsServices:[],
				masTags: [],
				isShown: true,
				strPrevTaskResult:'',
				anchorServiceId:'',
				componentKey: 0,
			}
		},
		watch:{
			objTask: function(val){
				this.bIsInoeTasks = this.isInoeTasks();
				this.bIsGoodTasks = this.isGoodTasks();
				/**/this.bIsHelpTasks = this.isHelpTasks();
				this.activeTab = this.actTab();
				this.masPrevTask = [];
				//this.getPrevTask(true);
			}
		},
		computed: {
			editable(){
				if(typeof this.objTask.editable != 'undefined'){
					return this.objTask.editable;
				}
				return 0;
			},
			/*
			TimeToEnd(){
				let deadlineFormated = this.objTask.DEADLINE.replace(' ', 'T') +'Z';			
				let d = new Date();
				let newDateFormated = d.getFullYear() + '-' + ('0'+(d.getMonth()+1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2) + 'T' + ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2) + ':' + ('0' + d.getSeconds()).slice(-2) +'Z';
				//console.log(deadlineFormated);
				//console.log(newDateFormated);

				//let t = Date.parse(deadlineFormated) - Date.parse(new Date());
				let t = Date.parse(deadlineFormated) - Date.parse(newDateFormated);
				let seconds = Math.floor((t / 1000) % 60);
				let minutes = Math.floor((t / 1000 / 60) % 60);
				let hours = Math.floor((t / (1000 * 60 * 60)) % 24);
				let days = Math.floor(t / (1000 * 60 * 60 * 24));
				return `Осталось ${days} д ${hours} ч ${minutes} м`;
			},
			*/
			client_id(){
				if(typeof this.objTask.client_id != 'undefined'){
					return this.objTask.client_id;
				}
				return this.objClient.id;
			},
			client_phone(){
				if(typeof this.objTask.client_phone != 'undefined'){
					return this.objTask.client_phone.replace(/[^0-9]/g,"");
				}
				if(typeof this.objTask.client_phone_list != 'undefined'){
					return this.objTask.client_phone_list.replace(/[^0-9]/g,"");
				}
				return '';
			},
			strFIO(){
				if(typeof this.objTask.fio != 'undefined'){
					return this.objTask.fio;
				}
				return this.objClient.fio;
			},
			agent_id(){
				if(typeof this.objTask.agent_id != 'undefined'){
					return this.objTask.agent_id;
				}
				return this.objService.agent_id;
			},
			make_id() {
				if(typeof this.objTask.make_id != 'undefined'){
					return this.objTask.make_id;
				}
				return 'Someone';
			},
			BP_NAME(){
				if(typeof this.objTask.BP_NAME != 'undefined'){
					return this.objTask.BP_NAME;
				}
				return this.objService.BP_NAME;
			},
			BP_EXT_NAME(){
				if(typeof this.objTask.BP_EXT_NAME != 'undefined'){
					return this.objTask.BP_EXT_NAME;
				}
				return this.objService.BP_EXT_NAME;
			},
			/*			
			service_agent_name(){
				if(typeof this.objTask.agent_name != 'undefined'){
					return this.objTask.agent_name;
				}
				return this.objService.agent_name;
			},*/
			CardType(){
				let masType = ['cinc'];
				if(this.objTask.overdue=='1' && this.objTask.STATUS=='Новая'){
					masType.push('danger');
				} else if(this.objTask.overdue=='0' && this.objTask.STATUS=='Новая'){
					masType.push('primary');
				} else if(this.objTask.overdue>='0' && this.objTask.STATUS=='Готово' && this.objTask.STATUS_END !='OTHER'){ 
					masType.push('success');
				} else if(this.objTask.overdue>='0' && this.objTask.STATUS=='Готово' && this.objTask.STATUS_END=='OTHER'){ 
					masType.push('other');
				} else if(this.objTask.READONLY=='1' || this.objTask.STATUS=='В архве'){
					masType.push('info');
				}
				return masType.join(' ');
			},
			TaskEndsGood(){
				return this.objTask.ENDS.filter(taskEnd=>taskEnd.ttype=='GOOD')
			},
			TaskEndsBad(){
				return this.objTask.ENDS.filter(taskEnd=>taskEnd.ttype!='GOOD')
			},
		},
		methods: {
			forceTabsUpdate() {
				//при изменении значения value из компонета табс меняем componentKey, чтобы заапдейтить табы
				this.componentKey += 1;
				//console.log('this.componentKey ',this.componentKey );
			},
			anchorService(service_id){
				//this.anchorServiceId = service_id;
				this.$parent.$emit('anchorservice', service_id);

			},
			getDopFields(data){
				// console.log(data);
				if(data===true)this.masDopFields = [];
				if (this.masDopFields.length==0){
					this.$GVO.ApiCall('addons_fields.GET',{flt:{'obj_type':'tasks','obj_id':this.objTask.id}})
					.then((objApi) => {
						// console.log(objApi);
						if(objApi.success === true) {
							for (let i = 0; i < objApi.data.length; i++) {
								const element = objApi.data[i];
								this.masDopFields.push({
									id: element.id,
									field_type: element.field_type,
									name: element.name,
									elements: [{
										elementGetParamMap: 'crud_input',
										element_model: element.val,
										elementType: 'input',
										placeholder: 'Пиши в меня',
									}]
								});
							}
						}
					}).catch(errorObjApi => console.error(errorObjApi));
				}
			},
			getDopFieldsServices(data,bCollapseOpen=true){
				//console.log(data,bCollapseOpen);
				if(data===true)this.masDopFieldsServices = [];
				if (this.masDopFieldsServices.length==0 && bCollapseOpen===true){
					this.$GVO.ApiCall('addons_fields.GET',{flt:{'obj_type':'services','obj_id':this.objTask.service_id}})
					.then((objApi) => {
						//console.log(objApi);
						if(objApi.success === true) {
							for (let i = 0; i < objApi.data.length; i++) {
								const element = objApi.data[i];
								this.masDopFieldsServices.push({
									id: element.id,
									field_type: element.field_type,
									name: element.name,
									elements: [{
										elementGetParamMap: 'crud_input',
										element_model: element.val,
										elementType: 'input',
										placeholder: 'Пиши в меня',
									}]
								});
							}
						}
					}).catch(errorObjApi => console.error(errorObjApi));
				}
			},
			isDateLess(strDate){
				//console.log(moment().isSameOrAfter(strDate));
				return moment().isSameOrAfter(strDate);
			},
			isStartDateFar(strStartdate){
				let year = parseInt(strStartdate.slice(0, 4));
				if(year >= 3000){
					return true;
				}
				return false;
			},
			actTab(){
				let tabId='';
				//console.log('objTask', this.objTask);
				if(this.isGoodTasks()){
					tabId=this.objTask.id+'_tb1';
					//console.log('tabId', tabId);
					return tabId;
				}
				return '-1';
			},
			isInoeTasks(){
				if(this.objTask.BlockType != 'ClientCall'){
					if(typeof this.objTask.ENDS !='undefined'){
						for (let i = 0; i < this.objTask.ENDS.length; i++) {
							if(this.objTask.ENDS[i].ttype != 'GOOD') return true;
						}
					}
				}
				return false;
			},
			isGoodTasks(){
				if(this.objTask.BlockType != 'ClientCall'){
					if(typeof this.objTask.ENDS !='undefined'){
						for (let i = 0; i < this.objTask.ENDS.length; i++) {
							if(this.objTask.ENDS[i].ttype == 'GOOD') return true;
						}
					}
				}
				return false;
			},
			isHelpTasks(){
				if(typeof this.objTask.HELPS != 'undefined' && this.objTask.HELPS.length>0) {return true;}
				/**/else if (typeof this.objTask.HELPS != 'undefined' && this.objTask.HELPS.length === 0 && this.objTask.helpdesk_id == -1) {return false;}
				else {return false;}
			},
			isTimeToTask(){
				/*
				let t = Date.parse(this.objTask.STARTDATE) - Date.parse(new Date());				
				let minutes = Math.floor((t / 1000 / 60) % 60);
				let hours = Math.floor((t / (1000 * 60 * 60)) % 24);
				let days = Math.floor(t / (1000 * 60 * 60 * 24));	
				// let months = Math.floor(t / (1000 * 60 * 60 * 24 * 30.5));	
				// let year = Math.floor(t / (1000 * 60 * 60 * 24 * 30.5 * 12));

				if (days === 0 && hours > 0) {
					return `через ${hours} ч ${minutes} м`;
				} else if (days === 0 && hours === 0) { 
					return `через ${minutes} м`;
				} else return `через ${days} д ${hours} ч ${minutes} м`;
				*/
				if(this.objTask.STARTDATE=="3000-12-31 23:59:59") return `после просмотра клиентом презентации.`;
				//return `через ${moment(this.objTask.STARTDATE).diff(new Date(),'days')} д ${moment(this.objTask.STARTDATE).diff(new Date(),'hours')} ч ${moment(this.objTask.STARTDATE).diff(new Date(),'minutes')} м`;
				return `(` + moment(this.objTask.STARTDATE).fromNow() + `)`;
			},
			isTaskStartTime(){
				if(this.objTask.STARTDATE!="3000-12-31 23:59:59") {
				return `в ` + moment(this.objTask.STARTDATE).format("DD.MM.YYYY HH:mm");
				}
			},
			TimeOverdue(){
				if(this.objTask.SUCCESS_ENDDATE !='') {
					let t = Date.parse(this.objTask.SUCCESS_ENDDATE) - Date.parse(this.objTask.DEADLINE);

					let minutes = Math.floor((t / 1000 / 60) % 60);
					let hours = Math.floor((t / (1000 * 60 * 60)) % 24);
					let days = Math.floor(t / (1000 * 60 * 60 * 24));

					if (days === 0 && hours > 0) {
						return ` ${hours} ч ${minutes} м`;
					} else if (days === 0 && hours === 0) { 
						return ` ${minutes} м`;
					} else return ` ${days} д ${hours} ч ${minutes} м`;
				} else {
					//console.log('Старая задача, у нее нет поля SUCCESS_ENDDATE');
				}
			},
			GetAgentName(){
				this.cat_timer = setInterval(() => {
					if(typeof this.$GVO.GetCat('CAT_STAFF',this.agent_id).name != 'undefined' && this.agent_id != 0){
						this.agent_name = this.$GVO.GetCat('CAT_STAFF',this.agent_id).name
						clearTimeout(this.cat_timer);
						this.cat_timer = null;
					}else{
						this.agent_name = this.agent_id;
					}
				}, 250);
				return this.$GVO.GetCat('CAT_STAFF',this.agent_id).name;
			},
			GetMakerName(){
				this.cat_timer = setInterval(() => {
					if(typeof this.$GVO.GetCat('CAT_STAFF',this.agent_id).name != 'undefined' && this.make_id != 0){
						this.maker_name = this.$GVO.GetCat('CAT_STAFF',this.make_id).name
						clearTimeout(this.cat_timer);
						this.cat_timer = null;
					}else{
						this.maker_name = this.make_id;
					}
				}, 250);
				return this.$GVO.GetCat('CAT_STAFF',this.maker_id).name;
			},
			getPrevTask(clps){
				//console.log('getPrevTask',clps);
				//clps=true;
				//console.log('getPrevTaskBtn');
				//console.log(this.objTask.id);
				if(clps===true){
					this.$GVO.ApiCall('GET_PREV_TASK_RESULTS',{obj:'services', flt:{id:this.objTask.id}})
						.then((objApi) => {
							if(objApi.success){
								this.masPrevTask = objApi.data;
							}else{
								this.masPrevTask = [];
								this.strPrevTaskResult = 'Результатов нет';
							}
						})
						.catch((errorObjApi) => {console.error(errorObjApi); this.masPrevTask = [];});
				}
			},
			getPrevTaskBtn(){
				//console.log('getPrevTaskBtn');
				//console.log(this.objTask.id);
				this.$GVO.ApiCall('GET_PREV_TASK_RESULTS',{obj:'services', flt:{id:this.objTask.id}})
					.then((objApi) => {
						if(objApi.success){
							this.masPrevTask = objApi.data;
						}else{
							this.masPrevTask = [];
							this.strPrevTaskResult = 'Результатов нет';
						}
					})
					.catch((errorObjApi) => {console.error(errorObjApi); this.masPrevTask = [];});
				
			},
			StartNow(){
				swal({
					title: 'Вы точно хотите начать задачу досрочно?',
					text: 'Вы не сможете отменить запуск задачи после подтверждения',
					type: 'warning',
					showCancelButton: true,
					confirmButtonText: 'Да, начать сейчас',
					cancelButtonText: 'Нет',
					showCloseButton: true,
					showLoaderOnConfirm: true,
					buttonsStyling: false,
					focusConfirm: false,
					confirmButtonClass: 'btn btn-success btn-fill',
					cancelButtonClass: 'btn btn-danger btn-fill',
				}).then((result) => {
					if(result.value) {
						swal('Начато', 'Вы успешно запустили задачу', 'success', 'btn btn-success btn-fill');

						/**/
						this.$GVO.ApiCall('services.START_TASK_NOW',{flt:{id:this.objTask.id}})
						.then((objApi) => {
							// if(objApi.success){
							// 	// console.log(objApi);
								
							// }
						})
						.catch((errorObjApi) => {console.error(errorObjApi);});
						

					} /*else {
						swal('Отменено', 'Вы отменили запуск задачи', 'error', 'btn btn-success btn-fill')
					}*/
				});

				
			},
			handleUpdateRecord(row, newRecord) {
				// Обновляем RecID в объекте строки
				row.dw_file = newRecord;
			},			
		},
		mounted(){
			this.masPrevTask = [];

			if(typeof this.$GVO.cats.CAT_BP_TASK_TAGS == 'undefined'){
				this.$GVO.LoadCatPromise('CAT_BP_TASK_TAGS')
				.then((objApi) => {
					for (let i = 0; i < this.$GVO.cats.CAT_BP_TASK_TAGS.length; i++) {
						const element = this.$GVO.cats.CAT_BP_TASK_TAGS[i];
						if(element.act==1) this.masTags.push({'value':element.val,'label':element.name, 'id':element.id}); //вопрос val или id ?
					}
				})
				.catch(errorObjApi => {console.error(errorObjApi); });
			}else{
				for (let i = 0; i < this.$GVO.cats.CAT_BP_TASK_TAGS.length; i++) {
					const element = this.$GVO.cats.CAT_BP_TASK_TAGS[i];
					if(element.act==1) this.masTags.push({'value':element.val,'label':element.name, 'id':element.id}); //вопрос val или id ?
				}
			}
			/*if(typeof this.$route.query.client_id != 'undefined' && typeof this.$route.query.service_id != 'undefined' && typeof this.$route.query.task_id != 'undefined' && typeof this.objService == 'undefined'){
				this.GetServiceData();
			}*/
		},
		created(){
			if(location.pathname.indexOf('/data/clients/id') != -1){this.isShown = false;} else {this.isShown = true;}
		}
	}
</script>
<style lang="scss">
	.ReCardTask .oneline > *{display: inline-block;}
	.ReCardTask .description {font-size: 14px;}
	.ReCardTask .description a{cursor: pointer;}
	.ReCardTask .description a > i{margin-right: 10px;}
	.ReCardTask .date{font-size: 12px; margin-top: 5px; display: inline-flex;}
	.ReCardTask .date span, .taskDeadline span {margin-right: 10px;}
	.ReCardTask .nav.nav-pills {flex-wrap: nowrap;}

	.ReCardTask .taskInfo .form-check.disabled .form-check-label, .form-check.disabled .form-check-label{color:white; opacity: 1;}
	.ReCardTask .white-content .card:not(.card-white) .lightTheme-BG {background: #f1f6fc!important; box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.08);} 
	/*.white-content .card:not(.card-white) .lightTheme-BG {background: #ebedf3!important; box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.08);} */
	
	.ReCardTask .nav-pills .nav-item .nav-link {min-width: 56px; padding: 0px 11px;}

	.overdue-text{color: #F84E54!important;}
	.card-overdue{box-shadow: 0 1px 20px 0 rgba(255, 2, 2, 0.25)!important;}
	.card-other {border: 1px solid #F84E54!important;}

	.BP-row {display: flex; justify-content: space-between;}
	.BP-id {min-width: 70px; text-align: end;}
	.results {padding-left: 25px;}
	.badge-grey {background: #9A9A9A; color: #fff;}
	.ReCardTask .card-collapse .card:not(.card-cinc) .card-header a {color: #01B0E0;}
	.ReCardTask .card-header {padding-bottom: 0px!important;}
	/*.result-marker li::before {content: "\20DD"; color: #01B0E0; padding-right: 18px; font-size: 12px; font-weight: normal;}*/

	.ReCardTask .list-unstyled li {
		padding-left: 8px;
	}
	audio.call-audio {
		outline: none;
		border-radius: 2rem;
		background-color: transparent;
		border: 1px solid #01B0E0;
		box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.3);
	}
	figure {margin-bottom: 0px;}

	/*.white-content .card:not(.card-white) .lightTheme-BG {border: 1px solid #c4c4c4;}*/

	figure > *{display: inline-block;}
	figure > a.a-dwld{
		font-size: 35px;
		vertical-align: top;
		margin-top: 10px;
		margin-left: 20px;
	}

	.taskEndCollapse .card-collapse .card:not(.card-cinc) .card-header, 
	.crud-container .card-collapse .card:not(.card-cinc) .card-header, 
	.masPrevTaskCollapse .card-collapse .card:not(.card-cinc) .card-header {padding-top: 8px!important;}
	/*
	.taskEndCollapse .card-collapse .card .card-header a {color: #00bf9a!important; } 
	.taskEndCollapse .card-collapse > .card > .card-header {border-bottom: 2px solid #00bf9a!important;}
	.taskEndCollapse .card-collapse .card:not(.card-cinc) .card-header a i {color: #00bf9a!important;}
	*/
	.taskEndCollapse .card-collapse .card:not(.card-cinc) .card-body {padding-left: 0px; padding-right: 0px;}

	.taskEndCollapse .form-options-group h6 {padding-left: 15px;}
	.taskEndCollapse .card .card-footer {padding-top: 0!important;}

	.swal2-popup .swal2-styled.swal2-confirm {
		background-color: #00BF9A;
		background-image: linear-gradient(to right, #00BF9A, #1d83bd);
		outline: none;
	}
	.swal2-popup .swal2-actions:not(.swal2-loading) .swal2-styled:hover {
		box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
		transform: translateY(-1px);
		background-image: linear-gradient(to right, #00BF9A, #1d83bd);
	}
	.isHiddenTask {
		display: none;
	}
	.isVisibleTask {
		display: block;
	}
	.ReCardTask .crud-container .card-body {
		padding-left: 0px !important;
		padding-right: 0px !important;
	}

	@media (max-width: 400px) {
		audio {width: 215px;}
	}
	@media (max-width: 853px) and (min-width: 768px) {
		audio {width: 230px;}
	}
	@media (max-width: 786px) {
		.taskEndCollapse, .masPrevTaskCollapse  {margin-bottom: 15px;}
		.taskEndCollapse .card-collapse .card:not(.card-cinc) .card-header {font-size: 16px;}/**/
		.ReCardTask .nav-pills .nav-item .nav-link {padding: 5px 11px;}
	}
	
	
	@media (max-width: 920px){
		.tab-label > span.text{ display: none; }
		.inoneline .tab-label .tab-icon{margin-right: 0px;}
		.taskDeadline {flex-wrap: wrap;}
	}
	@media (max-width: 525px){
		/*.ReCardClientEdit .inoneline {}*/ /* перенёс в src/assets/sass/dashboard/custom/_global.scss , т.к. тут не работает*/
		.inoneline .tab-label{
			height: 14px;
			margin-top: 5px;
		}
		.inoneline .tab-label .tab-icon{
			font-size: 14px;
			line-height: 100%;
		}
		.BP-row {flex-wrap: wrap;}
	}
	// main.scss
	// @import "node_modules/bootstrap/scss/variables";
	/*
	.ReCardTask{
		.lenta-field{
			 color: var(--bs-dark);
		}
	}
	*/
</style>
